<template>
  <!-- テキスト入力 -->
  <form class="form-inline">
    <div
      class="form-group mx-sm-3 mb-2"
      v-for="(t, idx) in question.question.answer"
      :key="`form${idx}`"
    >
      <input
        class="form-control text-formans"
        id="text-form"
        :placeholder="inputPlaceHolder[idx]"
        v-if="!sent"
        v-model="input[idx]"
        :ref="`input${idx}`"
      />
      <div v-else>
        {{ inputResponse[idx] }}
        <p class="answer">
          <img v-if="inputAnswer[idx]" src="@/assets/img/maru.png" />
          <img v-else src="@/assets/img/batsu.png" />
          正答：
          <span v-if="!inputAnswer[idx]">
            <span v-if="Array.isArray(t)">{{ t[0] }}</span>
            <span v-else>{{ t }}</span>
          </span>
          <span v-else>{{ inputResponse[idx] }}</span>
        </p>
      </div>
    </div>
  </form>
  <!-- テキスト入力の解答 ここまで-->
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      input: [],
    };
  },
  mounted() {
    if (this.response && this.sent) {
      this.input = this.response;
    }
  },
  methods: {

  },
  computed: {
    response() {
      return this.$store.getters.response;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.modal;
    },
    question() {
      return this.$store.getters.question;
    },
    inputAnswer() {
      return this.$store.getters.answer.map((e, idx) => {
        if (this.response) {
          if (this.response[idx]) {
            if (Array.isArray(e)) {
              return (
                e.map(a => String(a)).indexOf(String(this.response[idx])) !== -1
              );
            }
            console.log(String(e), String(this.response[idx]))
            return String(e) === String(this.response[idx]);
          }
          return null;
        } else {
          return null;
        }
      });
    },
    inputResponse() {
      return this.$store.getters.answer.map((e, idx) => {
        if (this.response) {
          if (this.response[idx]) {
            return String(this.response[idx]);
          }
          return null;
        } else {
          return null;
        }
      });
    },
    options() {
      return this.question.question.option;
    },
    inputPlaceHolder() {
      return this.question.question.answer.map((e, idx) => {
        if (Array.isArray(this.options)) {
          return this.options[idx] || `解答欄${idx + 1}`;
        }
        return `解答欄${idx + 1}`;
      });
    }
  },
  watch: {
    input(nv) {
      console.log(nv);

      const inputAnswer = this.$store.getters.answer.every((e, idx) => {
          if (nv[idx]) {
            if (Array.isArray(e)) {
              return (
                e.map(a => String(a)).indexOf(String(nv[idx])) !== -1
              );
            }
            return String(e) === String(nv[idx]);
          }
          return false;
      });

      this.$store.commit("setResponse", {response: nv,
      correct: inputAnswer
      });
    }
  }
};
</script>